class PlaceOrderController {
    /*@ngInject*/
    constructor(KlarnaPaymentService, KlarnaExpressService, CommonService) {
        this.requestPending = false;
        this.klarnaPaymentService = KlarnaPaymentService;
        this.klarnaExpressService = KlarnaExpressService;
        this.commonService = CommonService;
        this.redirectErrorUrl = this.commonService.getBaseUrl() + '/cart?error=true';
    }

    init(klarnaClientToken, selectedPaymentMode) {
        this.paymentMode = selectedPaymentMode;
        this.klarnaClientToken = klarnaClientToken;
        if (this.isNotEmpty(this.klarnaClientToken)) {
            // klarnaPayment is used
            if (this.paymentMode.startsWith('klarnaPayment')) {
                this.klarnaPaymentService.initWidget(this.klarnaClientToken);
                this.klarnaPaymentService.loadWidget();
            }
            // klarnaExpressButton is used
            else if (this.paymentMode.startsWith('klarnaExpress')) {
                this.klarnaExpressService.initWidget(this.klarnaClientToken);
                this.klarnaExpressService.loadWidget();
            }
        }
    }

    submit(form) {
        this.requestPending = true;
        // klarnaPayment is used
        if (this.paymentMode.startsWith('klarnaPayment')) {
            if (this.isNotEmpty(this.klarnaClientToken)) {
                this.klarnaPaymentService.authorize(this.klarnaAuthorizeCallback, form, this.redirectErrorUrl);
            } else {
                window.location.replace(this.redirectErrorUrl);
            }
        }
        // klarnaExpressButton is used
        else if (this.paymentMode.startsWith('klarnaExpress')) {
            if (this.isNotEmpty(this.klarnaClientToken)) {
                this.klarnaExpressService.authorize(this.klarnaAuthorizeCallback, form, this.redirectErrorUrl);
            } else {
                window.location.replace(this.redirectErrorUrl);
            }
        } else {
            form.$$element.submit();
        }
    }

    klarnaAuthorizeCallback(res, form, cartErrorUrl) {
        if (res.approved && res.show_form) {
            document.getElementById("authorizationToken").value = res.authorization_token;
            form.$$element.submit();
        } else {
            window.location.replace(cartErrorUrl);
        }
    }

    isNotEmpty(value) {
        return value !== null && value !== '';
    }

}

export default PlaceOrderController;